<ng-container *ngIf="step">
  <div
    style="padding: 0px 15px"
    class="feedback-step-inputs-wrapper"
    [ngStyle]="step.actions.length === 1 ? { 'padding-bottom': '10px' } : {}"
  >
    <div
      [ngClass]="
        step.additional_config.feedback_blocks.length > 1
          ? 'feedback-wrapper'
          : ''
      "
    >
      <ng-container
        *ngFor="
          let feedback of step.additional_config.feedback_blocks;
          let i = index
        "
      >
        <div
          *ngIf="feedback.message && feedback.message.message[currentLang]"
          [attr.id]="'feedback-question-' + i"
        >
          <div
            class="text-block chat-text-box agent-message-text agent-message-box"
            style="margin: 15px 0px"
            [innerHTML]="
              feedback.message.message[currentLang]
                | replaceVariables: dynamicVariables
            "
          ></div>
        </div>

        <!-- Switch between different feedback types -->
        <div [ngSwitch]="feedback.feedback_type">
          <!-- TEXTAREA Case -->
          <div *ngSwitchCase="'textarea'">
            <user-input-area
              (feedbackTextArea)="onFeedbackTextArea($event, i)"
              [placeholderText]="'enter_text_here' | translate"
              [autoFocus]="i === 0"
              [ariaLabel]="getFeedbackInputAriaLabel(feedback)"
              [ariaLabelledBy]="getFeedbackQuestionId(feedback, i)"
              [ariaDescribedBy]="errorMessage ? feedbackErrorMessageId : null"
              [ariaInvalid]="!!errorMessage"
              [ariaRequired]="isFeedbackRequired(feedback)"
              [inputId]="'feedback-input-' + i"
            ></user-input-area>
          </div>

          <!-- TEXTFIELD Case -->
          <div *ngSwitchCase="'textfield'">
            <user-input-area
              (feedbackTextArea)="onFeedbackTextArea($event, i)"
              [placeholderText]="'enter_text_here' | translate"
              [rows]="1"
              [autoFocus]="i === 0"
              [ariaLabel]="getFeedbackInputAriaLabel(feedback)"
              [ariaLabelledBy]="getFeedbackQuestionId(feedback, i)"
              [ariaDescribedBy]="errorMessage ? feedbackErrorMessageId : null"
              [ariaInvalid]="!!errorMessage"
              [ariaRequired]="isFeedbackRequired(feedback)"
              [inputId]="'feedback-input-' + i"
            ></user-input-area>
          </div>

          <!-- CHECKBOX Case -->
          <fieldset
            *ngSwitchCase="'checkbox'"
            #checkboxGroup
            class="feedback-fieldset"
            [attr.aria-invalid]="errorMessage ? 'true' : null"
            [attr.aria-describedby]="errorMessage ? feedbackErrorMessageId : null"
            [attr.aria-required]="isFeedbackRequired(feedback) ? 'true' : null"
          >
            <legend class="sr-only">
              {{ getFeedbackInputAriaLabel(feedback) }}
              <span *ngIf="isFeedbackRequired(feedback)">
                ({{ 'checkbox_required_sr' | translate }})
              </span>
            </legend>

            <div
              class="feedback-checkboxes-wrapper"
              [ngStyle]="
                step.additional_config.feedback_blocks.length === 1
                  ? { padding: '15px' }
                  : { padding: '0px' }
              "
            >
              <ng-container *ngFor="let option of feedback.checkbox_options">
                <mat-checkbox
                  class="feedback-checkbox-option"
                  [checked]="option.checked"
                  (change)="onCheckboxChange($event, option, i)"
                  ><div
                    class="user-select-option-checkbox-text"
                    [innerHTML]="
                      option.message[currentLang]
                        | replaceVariables: dynamicVariables
                    "
                  ></div
                ></mat-checkbox>
              </ng-container>
            </div>
          </fieldset>
        </div>
      </ng-container>
      <!-- here we display error message if any -->
      <ng-container *ngIf="errorMessage">
        <div
          class=""
          [attr.id]="feedbackErrorMessageId"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style="
            font-size: 14px;
            color: #f15a5e;
            font-weight: bold;
            margin-top: 5px;
            display: flex;
            align-items: center;
          "
        >
          <mat-icon
          [svgIcon]="'error-icon'"
          style="margin-right: 5px;"
          aria-hidden="true"
        ></mat-icon> {{ errorMessage | translate }}
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
